<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/admin/task-analyses-revised">{{
    utils.getLangTerm('ta-jsa-swms.list.account-title', 'TA/JSA/SWMS Templates') }}</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto">
      <button mat-raised-button color="primary" class="m-1 mr-2" [matMenuTriggerFor]="linkMenu" id="add">
        <mat-icon>add</mat-icon>
        Add {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }}
      </button>

      <mat-menu #linkMenu="matMenu">
        <button mat-menu-item (click)="onAdd()">
          Create New
        </button>
        <button mat-menu-item (click)="onSelectTemplates()">
          Select from Global Templates
        </button>
        <button mat-menu-item (click)="onCopyTemplates('all')">
          Copy all Global Templates
        </button>
      </mat-menu>

      <mat-menu #appMenu="matMenu">
        <button mat-menu-item (click)="dataSource.selectAllToggle()">
          <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon
            *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
          {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
        </button>
        <button *ngIf="dataSource.archived == 'false'" mat-menu-item (click)="onRemoveSelected()"
          [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>archive</mat-icon> Archive Selected
        </button>
        <button *ngIf="dataSource.archived == 'true'" mat-menu-item (click)="onRestoreSelected()"
          [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>restore</mat-icon> Restore Selected
        </button>
      </mat-menu>

      <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu"
        matTooltip="Use this menu to select/deselect records." style="min-width: 120px">
        <mat-icon>more_vert</mat-icon>
        List Menu
      </button>
    </span>

    <button mat-raised-button class="m-1 mr-xl-3" (click)="onFilter()"
      matTooltip="Click this button to display filter options.">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <form tourAnchor="tour.search" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
      <input class="form-control ml-0 mr-2 my-1" type="search" [(ngModel)]="dataSource.search" name="search"
        placeholder="Search" aria-label="Search" matTooltip="Search for records." />
      <button mat-raised-button color="secondary" type="submit" class="mx-0 my-1" matTooltip="Run the current search">
        <mat-icon>search</mat-icon> Search
      </button>
    </form>

  </div>

</nav>

<div class="mat-elevation-z8 scroll-box">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="id" matSortDirection="desc"
    matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        #
      </th>
      <td mat-cell *matCellDef="let ta_revised">
        {{ ta_revised.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="task_name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        {{ utils.getLangTerm('ta-jsa-swms.fields.task_name.label', 'Name') }}
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <span>
          <strong>{{ ta_revised.task_name | ellipsis: ['50'] }}</strong><br>
          <small>{{ ta_revised.task_description | ellipsis: ['100'] }}</small>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="approved">
      <th mat-header-cell *matHeaderCellDef>Approved<br> Status</th>
      <td mat-cell *matCellDef="let ta_revised">
        <span
          [class]='utils.getSiteTAStatusTextColor(app.user.id == ta_revised.approver_id && !ta_revised.approver_acknowledged ? "Required" : (ta_revised.approver_acknowledged ? "Approved" : "Pending"))'>
          {{ app.user.id == ta_revised.approver_id && !ta_revised.approver_acknowledged ? "Required" :
          (ta_revised.approver_acknowledged ? "Approved" : "Pending") }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="authorized">
      <th mat-header-cell *matHeaderCellDef>Authorized<br> Status</th>
      <td mat-cell *matCellDef="let ta_revised">
        <span
          [class]='utils.getSiteTAStatusTextColor(app.user.id == ta_revised.authorizer_id && !ta_revised.authorizer_acknowledged ? "Required" : (ta_revised.authorizer_acknowledged ? "Authorized" : "Pending"))'>
          {{ app.user.id == ta_revised.authorizer_id && !ta_revised.authorizer_acknowledged ? "Required" :
          (ta_revised.authorizer_acknowledged ? "Authorized" : "Pending") }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="supervisor_acknowledged">
      <th mat-header-cell *matHeaderCellDef>Supervisor<br> Acknowledged<br> Status</th>
      <td mat-cell *matCellDef="let ta_revised">
        <span
          [class]='utils.getSiteTAStatusTextColor((app.user.id == ta_revised.supervisor_id && !ta_revised.supervisor_acknowledged) ? "Required" : (ta_revised.supervisor_acknowledged ? "Acknowledged" : "Pending"))'>
          {{ (app.user.id == ta_revised.supervisor_id && !ta_revised.supervisor_acknowledged) ? "Required" :
          (ta_revised.supervisor_acknowledged ? "Acknowledged" : "Pending") }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tools">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Tools
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding text-wrap">
        <ng-container *ngIf="ta_revised.tools?.length">
          <div style="padding: 5px 0;">
            <mat-chip-set role="list" aria-label="List of Tools selected">
              <mat-chip role="listitem" *ngFor="let tool of ta_revised.tools; let i = index">{{ tool.title }}</mat-chip>
            </mat-chip-set>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_by_user">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created By
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding">
        <span *ngIf="ta_revised?.created_by_user else showSystemCreator">
          <a (click)="onUserPublicView(ta_revised.created_by_user.hash)" matTooltip="View User Public Profile">
            {{ ta_revised.created_by_user.contact_person }}
          </a>
        </span>
        <ng-template #showSystemCreator>System</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding">
        <span>
          {{ (ta_revised.date_created * 1000) | timezoneConvertMedium }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At (UTC)
      </th>
      <td mat-cell *matCellDef="let ta_revised" class="no-padding">
        <span>
          {{ (ta_revised.date_created * 1000) | timezoneConvertUTCMedium }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="300"></th>

      <td mat-cell *matCellDef="let ta_revised">
        <button *ngIf="dataSource.archived == 'false'" type="button" mat-button [routerLink]="ta_revised.id + '/view'">
          View
        </button>

        <button *ngIf="dataSource.archived == 'false'" type="button" mat-button [routerLink]="ta_revised.id + '/edit'">
          Edit
        </button>

        <button *ngIf="dataSource.archived == 'false'" type="button" mat-button (click)="onClone(ta_revised)">
          Clone
        </button>

        <button *ngIf="dataSource.archived == 'false'" type="button" mat-button (click)="onRemove(ta_revised)">
          Archive
        </button>

        <button *ngIf="dataSource.archived == 'true'" type="button" mat-button (click)="onRestore(ta_revised.id)">
          Restore
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [length]="dataSource?.total | async" [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons>
  </mat-paginator>
</div>